import { createContext, useContext } from 'react';

export interface SurfaceContextValue {
  workspaceId: string;
  themeKey?: number;
  onComponentPropsChange?: (nodeId: string, props: Record<string, unknown>) => void;
}

const SurfaceContext = createContext<SurfaceContextValue | null>(null);
SurfaceContext.displayName = 'SurfaceContext';

export const SurfaceProvider = SurfaceContext.Provider;

export function useSurfaceContext(): SurfaceContextValue {
  const ctx = useContext(SurfaceContext);
  if (!ctx) {
    throw new Error('useSurfaceContext must be used within a SurfaceProvider');
  }
  return ctx;
}
